import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { ContentBody, Table } from '../../../../core/components'
import { useCustomerFinancials } from '../../../../services/queries/customer'
import { formatCurrency } from '../../../../utils/format/currencyFormat'
import { dateFormat } from '../../../../utils/format/dateFormat'

export const FinancialTab = () => {
  const { id }: any = useParams()
  const {
    data: financials,
    error,
    isLoading
  }: any = useCustomerFinancials({
    page: 1,
    limit: 99999,
    id
  })

  const lastProductsColumns = useMemo(
    () => [
      {
        title: 'Tipo NF',
        dataIndex: 'nfType'
      },
      {
        title: 'NF',
        dataIndex: 'nf'
      },
      {
        title: 'Data de Emissão',
        dataIndex: 'date',
        render: (value: string) => dateFormat(value)
      },
      {
        title: 'Data de Vencimento',
        dataIndex: 'dueDate',
        render: (value: string) => dateFormat(value)
      },
      {
        title: 'Valor',
        dataIndex: 'value',
        render: (value: any) => formatCurrency(value)
      },
      {
        title: 'Saldo',
        dataIndex: 'balance'
      },
      {
        title: 'Situação',
        dataIndex: 'situation'
      },

      {
        title: 'Tipo',
        dataIndex: 'type'
      }
    ],
    []
  )

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <>
      <ContentBody>
        <Table
          dataSource={financials?.data || []}
          columns={lastProductsColumns}
          bordered
        />
      </ContentBody>
    </>
  )
}
